import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=0325014f&"
import script from "./AdminDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports